<app-table-header-column *ngFor="let column of displayedColumns" [name]="column.name" [size]="column.size">
  <span content>{{ column.label }}</span>
</app-table-header-column>
